module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.table) ? _c('table', {
    staticStyle: {
      "border-collapse": "collapse"
    }
  }, [_c('tr', _vm._l((_vm.table.fields), function(field) {
    return _c('td', {
      key: 'hdr-' + field.name,
      staticClass: "no-wrap",
      class: _vm.cellClass(field),
      staticStyle: {
        "color": "#777",
        "font-weight": "bolder",
        "padding": "8px",
        "max-width": "150px",
        "border-bottom": "solid 1px #ddd"
      }
    }, [_vm._v("\n            " + _vm._s(field.title) + "\n        ")])
  }), 0), _vm._v(" "), _vm._l((_vm.table.records), function(record) {
    return _c('tr', {
      key: record['.key'],
      staticClass: "hoverable"
    }, _vm._l((_vm.table.fields), function(field) {
      return _c('td', {
        key: field.name,
        staticClass: "no-wrap",
        class: _vm.cellClass(field),
        staticStyle: {
          "color": "#444",
          "padding": "7px 12px",
          "max-width": "150px",
          "border-bottom": "solid 1px #ddd"
        }
      }, [_vm._v("\n            " + _vm._s(record[field.name]) + "\n        ")])
    }), 0)
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-693ba0ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ScreenTable.vue
// module id = 2584
// module chunks = 1